import { Routes } from '@front-app/constants/routes';
import { SetupContext } from '@vue/composition-api';
import { Location } from 'vue-router';

export enum ShareContentPanelState {
	CLOSED = 'closed',
	FILE = 'file',
	LINK = 'link',
}

export const routeToShareContentWithQuery = (
	query: Record<string, string | (string | null)[]>,
	shareContentPanelState: ShareContentPanelState,
	shareToDiscussionId?: string,
): Location => ({
	query: {
		...query,
		share: shareContentPanelState,
		shareToDiscussionId,
	},
});

/**
 * @deprecated
 */
export const routeToShareContent = (
	ctx: SetupContext,
	shareContentPanelState: ShareContentPanelState,
	shareToDiscussionId?: string,
): Location => routeToShareContentWithQuery(ctx.root.$route.query, shareContentPanelState, shareToDiscussionId);

export const routeToContentInfoWithQuery = (
	query: Record<string, string | (string | null)[]>,
	contentId: string,
	share?: ShareContentPanelState,
	shareToDiscussionId?: string,
): Location => {
	if (shareToDiscussionId) {
		return ({
			name: Routes.GROUP_DISCUSSION,
			query: {
				...query,
				share,
				showContent: contentId,
				shareToDiscussionId,
			},
		});
	}
	return ({
		name: Routes.GROUP_CONTENT,
		query: { ...query, share, showContent: contentId },
	});
};

/**
 * @deprecated
 */
export const routeToContentInfo = (
	ctx: SetupContext,
	contentId: string,
	share?: ShareContentPanelState,
	shareToDiscussionId?: string,
): Location => routeToContentInfoWithQuery(ctx.root.$route.query, contentId, share, shareToDiscussionId);
